import { render, staticRenderFns } from "./InsurerPaintMaterials.vue?vue&type=template&id=c2d11330"
import script from "./InsurerPaintMaterials.vue?vue&type=script&lang=js"
export * from "./InsurerPaintMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports